import { validateObject, validateField, isRequired } from "common/validation";
import { isBlank } from "common/general";
import { curry, mergeRight } from "ramda";

const constraints = fieldOptions => {
  let constraints = {
    firstName: {
      presence: {
        allowEmpty: false,
        message: "^validation_fname_required",
      },
    },
    lastName: {
      presence: {
        allowEmpty: false,
        message: "^validation_lname_required",
      },
    },
    email: {
      presence: {
        allowEmpty: false,
        message: "^validation_email_required",
      },
      email: {
        message: "^validation_email_invalid",
      },
    },
  };

  if (isRequired("local_library", fieldOptions)) {
    constraints = mergeRight(constraints, {
      localLibrary: (value, attributes) => {
        return isBlank(attributes.localLibrary) &&
          isBlank(attributes.localLibraryOther)
          ? {
              presence: {
                allowEmpty: false,
                message: "^validation_library_required",
              },
            }
          : null;
      },
      localLibraryOther: (
        value,
        attributes,
        attributeName,
        options,
        constraints
      ) =>
        isBlank(attributes.localLibrary) &&
        isBlank(attributes.localLibraryOther)
          ? {
              presence: {
                allowEmpty: false,
                message: "^validation_other_library_required",
              },
            }
          : null,
    });
  }

  if (isRequired("country", fieldOptions)) {
    constraints = mergeRight(constraints, {
      country: {
        presence: {
          allowEmpty: false,
          message: "^validation_country_required",
        },
      },
    });
  }

  if (isRequired("region", fieldOptions)) {
    constraints = mergeRight(constraints, {
      region: {
        presence: {
          allowEmpty: false,
          message: "^validation_region_required",
        },
      },
    });
  }

  if (isRequired("locality", fieldOptions)) {
    constraints = mergeRight(constraints, {
      locality: {
        presence: {
          allowEmpty: false,
          message: "^validation_city_required",
        },
      },
    });
  }

  if (isRequired("freeform_personal_data", fieldOptions)) {
    constraints = mergeRight(constraints, {
      freeformPersonalData: {
        presence: {
          allowEmpty: false,
          message: "^validation_freeform_personal_data_required",
        },
      },
    });
  }

  if (isRequired("freeform_personal_data_2", fieldOptions)) {
    constraints = mergeRight(constraints, {
      freeformPersonalData2: {
        presence: {
          allowEmpty: false,
          message: "^validation_freeform_personal_data_2_required",
        },
      },
    });
  }

  return constraints;
};

export const validateIntroField = (field, value, fieldOptions, errors = {}) =>
  validateField(constraints(fieldOptions), field, value, errors);

export const validateIntro = curry((fieldOptions, fields) =>
  validateObject(constraints(fieldOptions), fields)
);

// export const validateIntroField = (field, value, errors = {}) =>
//   validateField(constraints, field, value, errors);
//
// export const validateIntro = validateObject(constraints);
